// /src/components/LangLink.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getLangFromPath, buildPathWithLang } from '../i18n/lang';

export default function LangLink({ to, children, ...rest }) {
  const loc = useLocation();
  const lang = getLangFromPath(loc.pathname);

  // Абсолютные внешние ссылки и якоря/почта оставляем как есть
  const isExternal = typeof to === 'string' && /^(https?:)?\/\//i.test(to);
  const isHashOrMail = typeof to === 'string' && (/^#/.test(to) || /^mailto:/i.test(to));

  const finalTo =
    typeof to === 'string' && !isExternal && !isHashOrMail
      ? buildPathWithLang(lang, to)
      : to;

  return (
    <Link to={finalTo} {...rest}>
      {children}
    </Link>
  );
}
